import React from 'react';
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
} from '@mui/material';

function StipendPayrollResultsTable({ results = [], totalDays }) {
  if (!Array.isArray(results) || results.length === 0) {
    return null;
  }

  const getName = (row) => {
    if (row?.name) return row.name;
    const first = row?.first_name || '';
    const last = row?.last_name || '';
    const combined = `${first} ${last}`.trim();
    return combined || '-';
  };

  const getDaysWorked = (row) => {
    if (row?.total_worked_days != null) return row.total_worked_days;
    if (row?.present_days != null) return row.present_days;
    return '-';
  };

  return (
    <TableContainer component={Paper} elevation={1}>
      <Table size="small">
        <TableHead>
          <TableRow sx={{ backgroundColor: '#212529', color: 'white' }}>
            <TableCell sx={{ fontWeight: 'bold', color: 'white', textAlign: 'center' }}>
              Sr. No.
            </TableCell>
            <TableCell sx={{ fontWeight: 'bold', color: 'white', textAlign: 'center' }}>
              Intern/Apprentice Code
            </TableCell>
            <TableCell sx={{ fontWeight: 'bold', color: 'white', textAlign: 'left' }}>
              Name
            </TableCell>
            <TableCell sx={{ fontWeight: 'bold', color: 'white', textAlign: 'center' }}>
              Days Worked
            </TableCell>
            <TableCell sx={{ fontWeight: 'bold', color: 'white', textAlign: 'center' }}>
              Total Days
            </TableCell>
            <TableCell sx={{ fontWeight: 'bold', color: 'white', textAlign: 'center' }}>
              Stipend Amount
            </TableCell>
            {/* <TableCell sx={{ fontWeight: 'bold', color: 'white', textAlign: 'center' }}>
              Effective From
            </TableCell> */}
            <TableCell sx={{ fontWeight: 'bold', color: 'white', textAlign: 'center' }}>
              Net Pay
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {results.map((row, index) => (
            <TableRow key={row.id ?? row.employee_id ?? index} hover>
              <TableCell sx={{ textAlign: 'center' }}>{index + 1}</TableCell>
              <TableCell sx={{ textAlign: 'center' }}>{row.employee_code || '-'}</TableCell>
              <TableCell sx={{ textAlign: 'left' }}>{getName(row)}</TableCell>
              <TableCell sx={{ textAlign: 'center' }}>{getDaysWorked(row)}</TableCell>
              <TableCell sx={{ textAlign: 'center' }}>{row.total_days ?? totalDays}</TableCell>
              <TableCell sx={{ textAlign: 'center' }}>
                {row.stipend_amount != null
                  ? `₹ ${Math.round(Number(row.stipend_amount)).toLocaleString('en-IN')}`
                  : '-'}
              </TableCell>
              {/* <TableCell sx={{ textAlign: 'center' }}>{row.effective_from_date}</TableCell> */}
              <TableCell sx={{ textAlign: 'center' }}>
                {row.prorated_pay != null
                  ? `₹ ${Math.round(Number(row.prorated_pay)).toLocaleString('en-IN')}`
                  : '-'}
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
}

export default StipendPayrollResultsTable;

